import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useEditStaticWidgetAction } from './useEditStaticWidgetAction';
import { jsx as _jsx } from "react/jsx-runtime";
const EditNoteAction = () => {
  const {
    problem,
    Message,
    handleEdit
  } = useEditStaticWidgetAction({
    widgetType: 'note'
  });
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !problem,
    title: Message && /*#__PURE__*/_jsx(Message, {}),
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "widget-action-edit-note",
      use: "tertiary-light",
      size: "extra-small",
      onClick: handleEdit,
      disabled: !!problem,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "noteWidget.edit"
      })
    })
  }, "edit-note");
};
export default EditNoteAction;